import script from "./PauseEndingSoonModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PauseEndingSoonModal.vue?vue&type=script&setup=true&lang=ts"

import "./PauseEndingSoonModal.vue?vue&type=style&index=0&id=2ed90739&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed90739"]])

export default __exports__